import { render, staticRenderFns } from "./CSSPage.vue?vue&type=template&id=290fc67a&scoped=true&"
import script from "./CSSPage.vue?vue&type=script&lang=js&"
export * from "./CSSPage.vue?vue&type=script&lang=js&"
import style0 from "./CSSPage.vue?vue&type=style&index=0&id=290fc67a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "290fc67a",
  null
  
)

export default component.exports